// Generat automat din README.md
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from '../layouts/DashboardLayout';

// Accounting pages
import EmitereFacturi from '../pages/Accounting/EmitereFacturi';
import UrmarirePlati from '../pages/Accounting/UrmarirePlati';
import RapoarteFinanciare from '../pages/Accounting/RapoarteFinanciare';
import ManagementDocumente from '../pages/Accounting/ManagementDocumente';
import MigrareDate from '../pages/Accounting/MigrareDate';
import VerificareDiscrepante from '../pages/Accounting/VerificareDiscrepante';
import IntegrareOffice360 from '../pages/Accounting/IntegrareOffice360';

// HR pages
import PortalAngajati from '../pages/HR/PortalAngajati';
import PlanificatorConcedii from '../pages/HR/PlanificatorConcedii';
import EvaluarePerformanta from '../pages/HR/EvaluarePerformanta';
import PlatformaElearning from '../pages/HR/PlatformaElearning';
import GestionareCVuri from '../pages/HR/GestionareCVuri';
import OrganigramaDigitala from '../pages/HR/OrganigramaDigitala';

// CRM pages
import Chatbot247 from '../pages/CRM/Chatbot247';
import IntegrareWhatsApp from '../pages/CRM/IntegrareWhatsApp';
import AnalizaPredictiva from '../pages/CRM/AnalizaPredictiva';
import AutomatizareRPA from '../pages/CRM/AutomatizareRPA';
import CRMComplet from '../pages/CRM/CRMComplet';

// Sales pages
import PreviziuneVanzari from '../pages/Sales/PreviziuneVanzari';
import OptimizareStocuri from '../pages/Sales/OptimizareStocuri';
import IstoricComenzi from '../pages/Sales/IstoricComenzi';
import RaportareAutomata from '../pages/Sales/RaportareAutomata';
import IntegrareLogistica from '../pages/Sales/IntegrareLogistica';

// Security pages
import Monitorizare247 from '../pages/Security/Monitorizare247';
import DetectareAmenintari from '../pages/Security/DetectareAmenintari';
import RaspunsAutomatizat from '../pages/Security/RaspunsAutomatizat';
import RaportareIncidente from '../pages/Security/RaportareIncidente';

// Cloud pages
import CloudDashboard from '../pages/Cloud/CloudDashboard';
import CloudFiles from '../pages/Cloud/CloudFiles';
import CloudUpload from '../pages/Cloud/CloudUpload';
import CloudBackup from '../pages/Cloud/CloudBackup';
import CloudSettings from '../pages/Cloud/CloudSettings';

// Integration pages
import Microsoft365Integration from '../pages/Integrations/Microsoft365Integration';
import ZoomIntegration from '../pages/Integrations/ZoomIntegration';
import { TeamsIntegration, SharePointIntegration, OutlookIntegration } from '../pages/Integrations/IntegrationPages';

// Marketing pages
import GenerareContinutAI from '../pages/Marketing/GenerareContinutAI';
import AnalizaPerformantaMarketing from '../pages/Marketing/AnalizaPerformantaMarketing';
import CampaniiEmail from '../pages/Marketing/CampaniiEmail';
import AdaptareLaPiata from '../pages/Marketing/AdaptareLaPiata';

// Enterprise pages
import DashboardExecutiv from '../pages/Enterprise/ExecutiveDashboard';
import AdvancedReportingEngine from '../pages/Enterprise/AdvancedReportingEngine';
import WorkflowAutomationEngine from '../pages/Enterprise/WorkflowAutomationEngine';
import EnterpriseOverview from '../pages/Enterprise/EnterpriseOverview';

// Placeholder component pentru paginile care nu au fost încă create
const PlaceholderPage = ({ title, description }) => (
  <div className="text-center py-20">
    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">{title}</h1>
    <p className="text-gray-600 dark:text-gray-400 mb-8">{description}</p>
    <div className="inline-block p-6 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
      <p className="text-blue-800 dark:text-blue-200 font-semibold">Pagină în dezvoltare</p>
      <p className="text-blue-600 dark:text-blue-400 text-sm mt-2">Această funcționalitate va fi implementată în curând</p>
    </div>
  </div>
);

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DashboardLayout />}>
          {/* Redirect root to accounting */}
          <Route index element={<Navigate to="/accounting/invoices" replace />} />
          
          {/* Accounting Routes */}
          <Route path="accounting/invoices" element={<EmitereFacturi />} />
          <Route path="accounting/payments" element={<UrmarirePlati />} />
          <Route path="accounting/reports" element={<RapoarteFinanciare />} />
          <Route path="accounting/documents" element={<ManagementDocumente />} />
          <Route path="accounting/migration" element={<MigrareDate />} />
          <Route path="accounting/verification" element={<VerificareDiscrepante />} />
          <Route path="accounting/integration" element={<IntegrareOffice360 />} />

          {/* HR Routes */}
          <Route path="hr/portal" element={<PortalAngajati />} />
          <Route path="hr/vacations" element={<PlanificatorConcedii />} />
          <Route path="hr/performance" element={<EvaluarePerformanta />} />
          <Route path="hr/elearning" element={<PlatformaElearning />} />
          <Route path="hr/cvs" element={<GestionareCVuri />} />
          <Route path="hr/organigram" element={<OrganigramaDigitala />} />

          {/* CRM Routes */}
          <Route path="crm/chatbot" element={<Chatbot247 />} />
          <Route path="crm/whatsapp" element={<IntegrareWhatsApp />} />
          <Route path="crm/analytics" element={<AnalizaPredictiva />} />
          <Route path="crm/automation" element={<AutomatizareRPA />} />
          <Route path="crm/complete" element={<CRMComplet />} />

          {/* Sales Routes */}
          <Route path="sales/forecast" element={<PreviziuneVanzari />} />
          <Route path="sales/inventory" element={<OptimizareStocuri />} />
          <Route path="sales/orders" element={<IstoricComenzi />} />
          <Route path="sales/reporting" element={<RaportareAutomata />} />
          <Route path="sales/logistics" element={<IntegrareLogistica />} />

          {/* Cloud Routes */}
          <Route path="cloud/dashboard" element={<CloudDashboard />} />
          <Route path="cloud/files" element={<CloudFiles />} />
          <Route path="cloud/upload" element={<CloudUpload />} />
          <Route path="cloud/backup" element={<CloudBackup />} />
          <Route path="cloud/settings" element={<CloudSettings />} />

          {/* Integration Routes */}
          <Route path="integrations/microsoft365" element={<Microsoft365Integration />} />
          <Route path="integrations/teams" element={<TeamsIntegration />} />
          <Route path="integrations/zoom" element={<ZoomIntegration />} />
          <Route path="integrations/sharepoint" element={<SharePointIntegration />} />
          <Route path="integrations/outlook" element={<OutlookIntegration />} />

          {/* Marketing Routes */}
          <Route path="marketing/content" element={<GenerareContinutAI />} />
          <Route path="marketing/email" element={<CampaniiEmail />} />
          <Route path="marketing/analytics" element={<AnalizaPerformantaMarketing />} />
          <Route path="marketing/adaptation" element={<AdaptareLaPiata />} />

          {/* Security Routes */}
          <Route path="security/monitoring" element={<Monitorizare247 />} />
          <Route path="security/threats" element={<DetectareAmenintari />} />
          <Route path="security/response" element={<RaspunsAutomatizat />} />
          <Route path="security/incidents" element={<RaportareIncidente />} />

          {/* Enterprise Routes */}
          <Route path="enterprise" element={<EnterpriseOverview />} />
          <Route path="enterprise/dashboard" element={<DashboardExecutiv />} />
          <Route path="enterprise/reporting" element={<AdvancedReportingEngine />} />
          <Route path="enterprise/workflows" element={<WorkflowAutomationEngine />} />
          <Route path="enterprise/database" element={
            <PlaceholderPage 
              title="Multi-Database Connector" 
              description="Enterprise integration cu Oracle, SAP, MongoDB, PostgreSQL în real-time" 
            />
          } />

          {/* Website Routes */}
          <Route path="website/responsive" element={
            <PlaceholderPage 
              title="Website Responsive" 
              description="Website modern și responsiv optimizat pentru toate dispozitivele" 
            />
          } />
          <Route path="website/native" element={
            <PlaceholderPage 
              title="Aplicații Native Android/iOS" 
              description="Aplicații mobile native cu funcționalități complete și sincronizare cloud" 
            />
          } />
          <Route path="website/admin" element={
            <PlaceholderPage 
              title="Panou Administrativ Website" 
              description="Dashboard pentru gestionarea conținutului și configurărilor website-ului" 
            />
          } />
          <Route path="website/seo" element={
            <PlaceholderPage 
              title="Optimizare SEO & Google Tools" 
              description="Optimizare automată SEO cu integrare Google Analytics și Search Console" 
            />
          } />

          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/accounting/invoices" replace />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;